import { render } from "./BoiteASon.vue?vue&type=template&id=27ddce54"
import script from "./BoiteASon.vue?vue&type=script&lang=js"
export * from "./BoiteASon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__